import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export const dateFormat = 'YYYY-MM-DD';
export const dayFormat = 'ddd, MMM D, YYYY';

export const castToGMT = (aDate, format = 'MM-DD-YYYY') => new Date(moment.utc(aDate, format).format(dateFormat));

export const castToLocal = (aDate, format = 'MM-DD-YYYY') => new Date(moment.utc(aDate, format).format(dayFormat));

export const castToUtcTimestamp = (aDate, format = 'MM-DD-YYYY') => new moment.utc(aDate, format).format();

export const compactedDateRange = (start, end, format = 'MM-DD-YYYY') => { // ie. 2018-01-01 to 2018-01-02 will return as "Jan 1 - 2, 2018"
  const startDate = start instanceof moment ? start : moment(start, format).utc();
  const endDate = end instanceof moment ? end : moment(end, format).utc();
  const range = moment.range(startDate, endDate);

  let compactedString = `${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`;
  if (range.diff('year') === 0) {
    compactedString = compactedString.replace(startDate.format(', YYYY'), '');

    if (range.diff('month') === 0) {
      compactedString = compactedString.replace(startDate.format(' MMM'), '');

      if (range.diff('day') === 0) {
        compactedString = compactedString.replace(startDate.format(' - D'), '');
      }
    }
  }

  return compactedString;
}